module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-save-0b17e4f796ff22762fa4784db750dd1a.svg";